@if (incomeTaxEntity$ | async) {
  @if (heeftOndernemingen) {
    <div class="row">
      <div class="col-auto col col-1" style="font-weight: bold">
      </div>
      <div class="col-auto col-2">
      </div>
      <div class="col-auto col-4" style="font-weight: bold">
        {{ labelBalansSlot }}
      </div>
      <div class="col-auto col-3" style="font-weight: bold">
        {{ labelBalansOpening }}
      </div>
      <div class="col-auto col-4"></div>
    </div>

    <form [formGroup]="immaterieleVasteActivaGoodwllFg">
      <div class="row">
        <div class="col-auto col col-1 pt-2">
          <p>Goodwill</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="aanschafWaarde"
                                            label="Aanschafwaarde"
                                            [disabledControl]="(immaterieleVasteActivaGoodwllFg.controls.waardeSlot.value ?? 0) === 0"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4 pt-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-3 pt-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="immaterieleVasteActivaOverigFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Overige immateri&euml;le vaste activa</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="aanschafWaarde"
                                            [disabledControl]="(immaterieleVasteActivaOverigFg.controls.waardeSlot.value ?? 0) === 0"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="materieleVasteActivaGebouwenEigenFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            <p>Gebouwen en terreinen</p>
          </div>
          <div class="col-auto col-2">
            <snelstart-venture-fiscaal-feature-spec-gebouwen-eigen></snelstart-venture-fiscaal-feature-spec-gebouwen-eigen>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeSlot"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeOpening"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
    <form [formGroup]="materieleVasteActivaMachinesFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Machines en installaties</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-machines-installaties></snelstart-venture-fiscaal-feature-spec-machines-installaties>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="materieleVasteActivaOverigFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Overige materi&euml;le vaste activa</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-overig-materiele-vaste-activa></snelstart-venture-fiscaal-feature-spec-overig-materiele-vaste-activa>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="financieleVasteActivaFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            <p>Financi&euml;le vaste activa</p>
          </div>
          <div class="col-auto col-2">
            <p></p>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeSlot"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeOpening"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
    <form
      [formGroup]="vlottendeActivaVoorraadFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            <p>Voorraad</p>
          </div>
          <div class="col-auto col-2">
            <p></p>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeSlot"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeOpening"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
    <form [formGroup]="vlottendeActivaVoorraadOhwFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Onderhanden werk</p>
        </div>
        <div class="col-auto col-2">
          <p></p>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="vlottendeActivaVorderingenDebiteurenFg">
      <div class="row">
        <div class="col-auto col col-1 pt-3">
          <p>Debiteuren</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="nominaleWaarde"
                                            label="Nominale waarde"
                                            [disabledControl]="(vlottendeActivaVorderingenDebiteurenFg.controls.waardeSlot.value ?? 0) === 0"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-3 pt-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col- auto custom-input-150 "
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4 pt-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="vlottendeActivaVorderingenOmzetbelastingFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Omzetbelasting</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-omzetbelasting-activa></snelstart-venture-fiscaal-feature-spec-omzetbelasting-activa>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="vlottendeActivaVorderingenOverigFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Overige vorderingen</p>
        </div>
        <div class="col-auto col-2">
          <p></p>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="effectenFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            <p>Effecten</p>
          </div>
          <div class="col-auto col-2">
            <p></p>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeSlot"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeOpening"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
    <form [formGroup]="liquideMiddelenFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Liquide middelen</p>
        </div>
        <div class="col-auto col-2">
          <p></p>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>

    <form [formGroup]="totalFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            @if (!heeftSamenwerkingsverband) {
              <b>Totaal activa</b>
            } @else {
              <b>Totaal activa samenwerkingsverband</b>
            }
          </div>
          <div class="col-auto col-2">
            <p></p>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [calculate]="getTotaalActivaOpening()"
                                              [decimals]="0"
                                              [disabledControl]="true"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="totaalSlot"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [calculate]="getTotaalActivaSlot()"
                                              [decimals]="0"
                                              [disabledControl]="true"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="totaalOpening"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
  } @else {
    <p>Er zijn geen ondernemingen gevonden.</p>
  }
}
